import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "15% off",
  "description": "",
  "published": "2006-11-12T00:00:00.000Z",
  "redirect_from": ["/blog/15-off/swizec/360"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`People are crazy, and I don't just mean your average misanthrophic `}{`_`}{`people are crazy, `}{`_`}{`I mean to say that as a species they are really really crazy. Just look at what happens when a large store decides to give a 15% discount on all their products on one specific Sunday that happens to be today. It's crazy, there were people bloody everywhere, I've never in my life seen queues that long, let alone on a Sunday. Moving around was so difficult I almost thought I was visiting a walrus colony on a sunbathing trip. Crazy!`}</p>
    <p>{`So what else happened, oh yeah, I found a really great way to procrastinate writing, it is trully amazing to what lengths writers will go to avoid the dreaded empty page syndrome. Ok so my pages aren't empty anymore and ok yes I did have ideas on how to continue, but it's just that difficult to do just that. So I wasted hours upon hours on making my desktop pretty and a generally awesome place to work in. It's much cleaner now and all that.`}</p>
    <p>{`If you really want to, you can see it `}<a parentName="p" {...{
        "href": "http://swizec.com/MyScreenie.png"
      }}>{`here`}</a>{`, but it's a large large image.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      